export default {
  name: 'maintenance',
  components: {
  },
  props: [],
  data() {
  },
  computed: {

  },
  mounted() {

  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/views/components/maintenance/maintenance.component.js